import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferralLinkedin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 25,
			cy: 25,
			r: 24.5,
			fill: "white",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6654 21.4271H17.6417C17.4631 21.4271 17.3184 21.5718 17.3184 21.7503V34.6767C17.3184 34.8553 17.4631 35 17.6417 35H21.6654C21.8439 35 21.9886 34.8553 21.9886 34.6767V21.7503C21.9886 21.5718 21.8439 21.4271 21.6654 21.4271Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6551 15C18.1911 15 17 16.1898 17 17.6522C17 19.1153 18.1911 20.3055 19.6551 20.3055C21.118 20.3055 22.3081 19.1152 22.3081 17.6522C22.3082 16.1898 21.118 15 19.6551 15Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.9001 21.1048C30.284 21.1048 29.0894 21.7995 28.3648 22.5889V21.7493C28.3648 21.5708 28.2201 21.4261 28.0415 21.4261H24.1881C24.0096 21.4261 23.8649 21.5708 23.8649 21.7493V34.6757C23.8649 34.8543 24.0096 34.999 24.1881 34.999H28.203C28.3816 34.999 28.5263 34.8543 28.5263 34.6757V28.2801C28.5263 26.125 29.1117 25.2854 30.614 25.2854C32.2502 25.2854 32.3802 26.6314 32.3802 28.391V34.6758C32.3802 34.8543 32.5249 34.999 32.7035 34.999H36.7198C36.8984 34.999 37.0431 34.8543 37.0431 34.6758V27.5854C37.0431 24.3808 36.432 21.1048 31.9001 21.1048Z",
			fill: "black"
		})
	]
});
export default SvgReferralLinkedin;
